// import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
// import { stompService } from 'services/socketService';
// import { downloadAssetsFile, startDownloadAssets } from '../functions/download';
// import { startUploadAssets } from '../functions/Upload';

// /* ----------------------------------
//    HELPERS
// ---------------------------------- */

// const createTempId = () => `temp-${Date.now()}-${Math.random().toString(36).slice(2)}`;

// /* ----------------------------------
//    DOWNLOAD PROGRESS CONFIG
// ---------------------------------- */

// export const DOWNLOAD_PROGRESS = {
//   PREPARING: { start: 0, end: 10 },
//   PROCESSING: { start: 10, end: 20 },
//   DOWNLOADING: { start: 20, end: 99 },
//   DONE: { start: 99, end: 100 },
// };

// export const UPLOAD_PROGRESS = {
//   PREPARING: { start: 0, end: 10 },
//   UPLOADING: { start: 10, end: 85 },
//   PROCESSING: { start: 85, end: 95 },
//   DONE: { start: 95, end: 100 },
// };

// const DownloadAssetsContext = createContext(null);

// /* ----------------------------------
//    GENERIC PROGRESS MAPPER
// ---------------------------------- */

// const mapProgress = (phase, percent = 0, states = DOWNLOAD_PROGRESS) => {
//   const cfg = states[phase];
//   if (!cfg) return 0;

//   if (cfg.start === cfg.end) return cfg.end;

//   return Math.min(cfg.end, cfg.start + Math.floor(((cfg.end - cfg.start) * percent) / 100));
// };

// /* ==================================
//    PROVIDER
// ================================== */

// export const DownloadAssetsProvider = ({ children }) => {
//   const [downloadingAssets, setDownloadingAssets] = useState([]);
//   const [globalDownloadProgress, setGlobalDownloadProgress] = useState(0);
//   const [refreshRef, setrefreshRef] = useState(0);

//   const uploadListeners = useRef([]);
//   const uploadIdMapRef = useRef({});
//   const uploadMetaRef = useRef({});

//   /* ----------------------------------
//    SOCKET SUBSCRIPTION
// ---------------------------------- */

//   useEffect(() => {
//     const unsubscribe = stompService.subscribe('/user/topic/media.dam.final', (data) => {
//       uploadListeners.current.forEach((cb) =>
//         cb({
//           ...data,
//           activityId: data.activityId || data.uniqueId,
//         }),
//       );

//       handleDownloadSocket(data);
//       handleUploadSocket(data);
//     });

//     return () => unsubscribe?.();
//   }, []);

//   /* ----------------------------------
//    DOWNLOAD SOCKET HANDLER
// ---------------------------------- */

//   const handleDownloadSocket = async (data) => {
//     const { uniqueId, status } = data;
//     if (!uniqueId) return;

//     if (status === 'PREPARING') {
//       updateStatus(uniqueId, 'PREPARING', mapProgress('PREPARING', 100));
//       return;
//     }

//     if (status === 'PROCESSING') {
//       updateStatus(uniqueId, 'PROCESSING', mapProgress('PROCESSING', 100));
//       return;
//     }

//     if (status === 'READY') {
//       updateStatus(uniqueId, 'DOWNLOADING', mapProgress('DOWNLOADING', 0));

//       notify(uniqueId, 'DOWNLOADING', mapProgress('DOWNLOADING', 0), data);

//       try {
//         await downloadAssetsFile({ downloadId: uniqueId }, (downloadPercent) => {
//           const progress = mapProgress('DOWNLOADING', downloadPercent);

//           updateStatus(uniqueId, 'DOWNLOADING', progress);
//           notify(uniqueId, 'DOWNLOADING', progress, data);
//         });

//         updateStatus(uniqueId, 'DONE', DOWNLOAD_PROGRESS.DONE.end);

//         notify(uniqueId, 2, DOWNLOAD_PROGRESS.DONE.end, data);

//         cleanup(uniqueId);
//       } catch {
//         updateStatus(uniqueId, 'FAILED', 0);
//         notify(uniqueId, 'FAILED', 0, data);
//         cleanup(uniqueId);
//       }

//       return;
//     }

//     if (status === 'FAILED') {
//       updateStatus(uniqueId, 'FAILED', 0);
//       notify(uniqueId, 'FAILED', 0, data);
//       cleanup(uniqueId);
//     }
//   };

//   /* ----------------------------------
//    START DOWNLOAD
// ---------------------------------- */

//   const startDownload = async (payload , apiURL) => {
//     const job = await startDownloadAssets(payload , apiURL);

//     notify(job.downloadId, 'PREPARING', 0, {});

//     setDownloadingAssets((prev) => [
//       ...prev,
//       {
//         id: job.downloadId,
//         payload,
//         fileName: job.fileName,
//         status: 'PREPARING',
//         progress: mapProgress('PREPARING', 0),
//         showProgress: true,
//       },
//     ]);
//   };

//   /* ----------------------------------
//    STATE HELPERS
// ---------------------------------- */

//   const updateStatus = (id, status, progress = 0) => {
//     setDownloadingAssets((prev) => {
//       const updated = prev.map((d) =>
//         d.id === id ? { ...d, status, progress, showProgress: true } : d,
//       );

//       const active = updated.find((d) => d.status === 'DOWNLOADING');

//       setGlobalDownloadProgress(active ? active.progress : 0);

//       return updated;
//     });
//   };

//   const cleanup = (id) => {
//     setDownloadingAssets((prev) => {
//       const updated = prev.filter((d) => d.id !== id);

//       const active = updated.find((d) => d.status === 'DOWNLOADING');

//       setGlobalDownloadProgress(active ? active.progress : 0);

//       return updated;
//     });
//   };

//   /* ----------------------------------
//    LISTENER NOTIFIER
// ---------------------------------- */

//   const notify = (id, status, progress, data = {}) => {
//     const meta = uploadMetaRef.current[id] || {};

//     uploadListeners.current.forEach((cb) => {
//       cb({
//         ...data,
//         activityId: data.activityId || id,
//         status,
//         progress,
//         totalNumberOfAsset: meta.totalNumberOfAsset,
//         successCount: meta.successCount || 0,
//         showProgress: true,
//       });
//     });
//   };

//   /* ----------------------------------
//    REGISTER LISTENER
// ---------------------------------- */

//   const registerUploadListener = (cb) => {
//     uploadListeners.current.push(cb);

//     return () => {
//       uploadListeners.current = uploadListeners.current.filter((fn) => fn !== cb);
//     };
//   };

//   /* ----------------------------------
//    START UPLOAD
// ---------------------------------- */

//   const UploadFiles = async (formData, totalfiles , API_URL) => {
//     const tempId = createTempId();

//     uploadMetaRef.current[tempId] = {
//       totalNumberOfAsset: totalfiles,
//       successCount: 0,
//       lastCalculatedUploaded: 0,
//     };

//     notify(tempId, 'PREPARING', 0, {
//       uploadId: tempId,
//       isTemp: true,
//     });

//     try {
//       const job = await startUploadAssets(formData, (percent) => {
//         const mapped = mapProgress('UPLOADING', percent, UPLOAD_PROGRESS);

//         const meta = uploadMetaRef.current[tempId];
//         if (!meta) return;

//         /* calculate uploaded files */

//         const uploadedFiles = Math.floor((percent / 100) * meta.totalNumberOfAsset);

//         if (uploadedFiles > meta.lastCalculatedUploaded) {
//           const diff = uploadedFiles - meta.lastCalculatedUploaded;

//           meta.successCount += diff;
//           meta.lastCalculatedUploaded = uploadedFiles;
//         }

//         notify(tempId, 'UPLOADING', mapped);
//       } , API_URL);

//       uploadIdMapRef.current[job.uploadId] = tempId;

//       uploadMetaRef.current[job.uploadId] = uploadMetaRef.current[tempId];

//       notify(tempId, 'SWAP', 0, {
//         action: 'SWAP',
//         oldId: tempId,
//         newId: job.uploadId,
//       });

//       return job;
//     } catch (err) {
//       notify(tempId, 'FAILED', 0);

//       delete uploadMetaRef.current[tempId];

//       throw err;
//     }
//   };

//   /* ----------------------------------
//    HANDLE UPLOAD SOCKET
// ---------------------------------- */

//   const handleUploadSocket = (data) => {
//     const { activityId: requestId, status, percent = 0 } = data;

//     if (!requestId) return;

//     const mappedId = requestId;

//     data = {
//       ...data,
//       showProgress: true,
//       progress: mapProgress(status, percent, UPLOAD_PROGRESS),
//     };

//     if (status === 1) {
//       notify(mappedId, 'PROCESSING', mapProgress('PROCESSING', 100, UPLOAD_PROGRESS), data);

//       return;
//     }

//     if (status === 2) {
//       const meta = uploadMetaRef.current[requestId];
//       uploadMetaRef.current[requestId] = {
//         ...uploadMetaRef.current[requestId],
//         Responsecount: uploadMetaRef.current[requestId]?.Responsecount
//           ? uploadMetaRef.current[requestId].Responsecount + 1
//           : 1,
//       };

//       const remaining = meta.Responsecount ?  meta.Responsecount + 1 : 1;

//       if (meta.totalNumberOfAsset && remaining >= meta.totalNumberOfAsset) {
//         notify(mappedId, 2, UPLOAD_PROGRESS.DONE.end, data);

//         delete uploadMetaRef.current[requestId];
//         delete uploadIdMapRef.current[requestId];

//         setrefreshRef((p) => p + 1);
//       }

//       return;
//     }

//     if (status === 'FAILED') {
//       notify(mappedId, 'FAILED', 0, data);

//       delete uploadMetaRef.current[requestId];
//       delete uploadIdMapRef.current[requestId];
//     }
//   };

//   /* ----------------------------------
//    PROVIDER VALUE
// ---------------------------------- */

// /* ----------------------------------
//    PREVENT PAGE RELOAD/CLOSE
// ---------------------------------- */

// // useEffect(() => {
// //   // const hasActiveOperations = () => {
// //   //   // active downloads
// //   //   const activeDownloads = downloadingAssets.some(
// //   //     (item) =>
// //   //       item.status !== 'DONE' &&
// //   //       item.status !== 'FAILED'
// //   //   );

// //   //   // active uploads
// //   //   const activeUploads = Object.keys(uploadMetaRef.current).length > 0;

// //   //   return activeDownloads || activeUploads;
// //   // };

// //   const handleBeforeUnload = (e) => {
// //     if (globalDownloadProgress  >= 98) return;

// //     e.preventDefault();

// //     // Required for Chrome
// //     e.returnValue = '';
// //   };

// //   window.addEventListener('beforeunload', handleBeforeUnload);

// //   return () => {
// //     window.removeEventListener('beforeunload', handleBeforeUnload);
// //   };
// // }, [globalDownloadProgress]);

//   return (
//     <DownloadAssetsContext.Provider
//       value={{
//         startDownload,
//         downloadingAssets,
//         registerUploadListener,
//         globalDownloadProgress,
//         DOWNLOAD_PROGRESS,
//         UploadFiles,
//         UPLOAD_PROGRESS,
//         refreshRef,
//       }}
//     >
//       {children}
//     </DownloadAssetsContext.Provider>
//   );
// };

// /* ----------------------------------
//    HOOK
// ---------------------------------- */

// export const useDownloadAssets = () => {
//   const ctx = useContext(DownloadAssetsContext);

//   if (!ctx) {
//     throw new Error('useDownloadAssets must be used inside DownloadAssetsProvider');
//   }

//   return ctx;
// };
import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { stompService } from 'services/socketService';
import {
  downloadAssetsFile,
  startDownloadAssets,
  flushPendingBandwidth,
  hasActiveDownloads,
  cancelDownload as cancelDownloadRequest,
  cancelAllDownloads as cancelAllDownloadRequests,
  extensionOf,
  mapPhaseProgress,
  DOWNLOAD_PROGRESS,
  UPLOAD_PROGRESS,
} from '../functions/download';
import { startUploadAssets, updateUploadStatus } from '../functions/Upload';
import { UploadAssetsURL } from 'components/Dam/DAM_API/urls';
import { detectBrowserAndDevice } from 'Common/Functions';
import { toast } from 'react-toastify';

/* ----------------------------------
   HELPERS
---------------------------------- */

// The id an upload is known by end to end: generated here, sent to /uploadFile
// as the `activityId` param, and carried on every socket event for it.
const UPLOAD_ID_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

const createUploadId = () =>
  Array.from(
    crypto.getRandomValues(new Uint8Array(12)),
    (b) => UPLOAD_ID_CHARS[b % UPLOAD_ID_CHARS.length],
  ).join('');

/* ----------------------------------
   NAMING AN UPLOAD

   An upload is one request, and it is named after what the user dropped: a
   folder by its folder name, a single asset by its file name. Both are readable
   straight off the FormData — every folder-aware caller already puts a
   `relativePaths` entry per file into it (`MyFolder/sub/a.png`) — so no call
   site has to pass a label in.

   This name is known before the first byte goes out, which is what lets the row
   read correctly while uploading and when cancelled, rather than waiting for
   the server to mention a file name.
---------------------------------- */

const describeUpload = (formData) => {
  if (typeof formData?.entries !== 'function') return {};

  const roots = new Set();
  const fileNames = [];

  for (const [key, value] of formData.entries()) {
    if (key.startsWith('relativePaths')) {
      if (typeof value === 'string' && value.includes('/')) {
        roots.add(value.replace(/^(\.\/|\/)/, '').split('/')[0]);
      }
      continue;
    }

    if (key.startsWith('files') && value?.name) fileNames.push(value.name);
  }

  // several folders in one request — naming one of them would be a lie
  const folderName = roots.size > 1 ? `${roots.size} folders` : [...roots][0] || '';

  return {
    folderName,
    // only when the request IS that one file, so a folder keeps its own name
    fileName: !folderName && fileNames.length === 1 ? fileNames[0] : '',
  };
};

// how long we hold a socket event whose job we haven't claimed yet.
// covers the race where READY arrives before the POST promise resolves.
const ORPHAN_EVENT_TTL = 30_000;

// where an upload sits in the processing band: how many assets the server has
// confirmed out of the total
const processingProgress = ({ Responsecount = 0, totalNumberOfAsset = 0 }) => {
  const { start, end } = UPLOAD_PROGRESS.PROCESSING;
  if (!totalNumberOfAsset) return start;

  return start + Math.floor((end - start) * (Responsecount / totalNumberOfAsset));
};

/* ----------------------------------
   UPLOADS THAT OUTLIVE A RELOAD

   Once the POST is in, the rest of an upload is server-side work: a reload
   doesn't stop it, but it wipes everything this tab knew about it. Keep just
   enough in sessionStorage to pick the row back up. sessionStorage is per tab,
   so a tab re-adopts its own uploads and never another tab's.
---------------------------------- */

const UPLOAD_STORE_KEY = 'dam.activeUploads';

// A restored upload that hears nothing for this long is taken as finished —
// events the server sent while the page was reloading are gone for good, so
// its count may never reach the total on its own. Entries already this quiet
// when the page loads are dropped instead of restored.
const RESTORED_UPLOAD_IDLE = 60_000;

const readStoredUploads = () => {
  try {
    return JSON.parse(sessionStorage.getItem(UPLOAD_STORE_KEY)) || {};
  } catch {
    return {};
  }
};

const writeStoredUploads = (uploads) => {
  try {
    if (Object.keys(uploads).length) {
      sessionStorage.setItem(UPLOAD_STORE_KEY, JSON.stringify(uploads));
    } else {
      sessionStorage.removeItem(UPLOAD_STORE_KEY);
    }
  } catch {
    // storage full or blocked — the upload itself carries on regardless
  }
};

const storeUpload = (id, meta) => {
  const uploads = readStoredUploads();

  uploads[id] = {
    totalNumberOfAsset: meta.totalNumberOfAsset,
    Responsecount: meta.Responsecount || 0,
    folderName: meta.folderName || '',
    fileName: meta.fileName || '',
    updatedAt: Date.now(),
  };

  writeStoredUploads(uploads);
};

const forgetStoredUpload = (id) => {
  const uploads = readStoredUploads();
  if (!uploads[id]) return;

  delete uploads[id];
  writeStoredUploads(uploads);
};

// statuses during which a download can still be stopped
const CANCELLABLE_DOWNLOAD_STATUSES = ['PREPARING', 'PROCESSING', 'DOWNLOADING'];

/* ----------------------------------
   UPLOAD CONFLICTS

   The server answers a duplicate file name with its own status instead of a
   completion event: the asset is parked until the user says whether to replace
   the existing file or keep both.
---------------------------------- */

const CONFLICT_STATUS = 'CONFLICT';

// These strings go on the wire as `status` in the update-upload-status call —
// change the values here if the backend spells its enum differently.
export const CONFLICT_CHOICE = {
  REPLACE: 'REPLACE',
  KEEP_BOTH: 'RENAME',
  CANCEL: 'CANCEL',
};

/* update-upload-status body. Every field but `status` is echoed straight back
   off the CONFLICT frame; `status` is the answer the user just gave. */
const buildConflictStatusPayload = (conflict, choice) => {
  const frame = conflict.payload || {};

  return {
    message: frame.message ?? '',
    status: choice,
    uploadId: frame.uploadId ?? conflict.activityId,
    existingId: frame.existingId ?? '',
    deviceId: frame.deviceId ?? detectBrowserAndDevice().deviceId,
    activityId: frame.activityId ?? conflict.activityId,
  };
};

const isConflictEvent = (data) =>
  String(data?.status ?? '').toUpperCase() === CONFLICT_STATUS;

// AssetName is the field the CONFLICT frame carries the duplicate's name in.
// The rest are fallbacks; the placeholder should never actually surface.
const pickConflictFileName = (data) =>
  data?.AssetName ||
  data?.assetName ||
  data?.fileName ||
  data?.name ||
  data?.originalFileName ||
  'This file';

/* ----------------------------------
   PROGRESS CONFIG

   These live in functions/download.js (breaks the old circular import).
   Re-exported here so existing imports from this module keep working.
---------------------------------- */

export { DOWNLOAD_PROGRESS, UPLOAD_PROGRESS };

const DownloadAssetsContext = createContext(null);

const mapProgress = mapPhaseProgress;

/* ==================================
   PROVIDER
================================== */

export const DownloadAssetsProvider = ({ children }) => {
  const [downloadingAssets, setDownloadingAssets] = useState([]);
  const [globalDownloadProgress, setGlobalDownloadProgress] = useState(0);
  const [refreshRef, setrefreshRef] = useState(0);

  // duplicate-name uploads waiting on the user's answer, oldest first
  const [uploadConflicts, setUploadConflicts] = useState([]);

  const uploadListeners = useRef([]);
  const uploadMetaRef = useRef({});

  const conflictKeysRef = useRef(new Set()); // guards against replayed frames
  const earlyConflictsRef = useRef(new Map()); // uploadId -> [event, ...]
  const conflictTimersRef = useRef(new Map()); // uploadId -> timeout id
  // mirrors uploadConflicts so socket callbacks (registered once) and the
  // resolver read the queue synchronously instead of a stale closure
  const uploadConflictsRef = useRef([]);

  /* ----------------------------------
     JOB OWNERSHIP

     /user/topic/... is a *user* destination: Spring fans it out to EVERY
     STOMP session of that principal — every tab AND every device on the same
     login. Only the session that created the job may act on it.
  ---------------------------------- */

  const ownedDownloadsRef = useRef(new Set());
  const ownedUploadsRef = useRef(new Set());
  const earlyEventsRef = useRef(new Map()); // downloadId -> [event, ...]
  const orphanTimersRef = useRef(new Map()); // downloadId -> timeout id
  const earlyUploadEventsRef = useRef(new Map()); // uploadId -> [event, ...]
  const uploadOrphanTimersRef = useRef(new Map()); // uploadId -> timeout id
  const restoredIdleTimersRef = useRef(new Map()); // uploadId -> timeout id
  // uploads this tab has closed out: a late frame for one is still ours, not
  // something to show as a new row
  const finishedUploadsRef = useRef(new Set()); // uploadId

  // an upload or download this tab runs (or ran) — reported by its handler
  const isOwnJob = (id) =>
    ownedUploadsRef.current.has(id) ||
    finishedUploadsRef.current.has(id) ||
    ownedDownloadsRef.current.has(id);
  // uploads whose bytes are still going up — the only time leaving the page
  // loses anything
  const sendingUploadsRef = useRef(new Set()); // uploadId
  const refreshTimerRef = useRef(null);

  // real file name / type per download, filled in from response headers
  const downloadMetaRef = useRef({});

  // refs so the socket callback (registered once) always sees current logic
  const handleDownloadSocketRef = useRef(null);
  const handleUploadSocketRef = useRef(null);

  /* ----------------------------------
     SOCKET SUBSCRIPTION
  ---------------------------------- */

  // useEffect(() => {
  //   const unsubscribe = stompService.subscribe('/user/topic/media.dam.final', (data) => {
  //     handleDownloadSocketRef.current?.(data);
  //     handleUploadSocketRef.current?.(data);
  //   });

  //   return () => unsubscribe?.();
  // }, []);

  /* ----------------------------------
     RE-ADOPT UPLOADS AFTER A RELOAD

     Declared before the socket subscription so it runs first: the first event
     after a reload already finds its upload claimed.
  ---------------------------------- */

  useEffect(() => {
    const stored = readStoredUploads();
    const now = Date.now();

    Object.entries(stored).forEach(([id, { updatedAt = 0, ...saved }]) => {
      // quiet since before the reload — most likely finished while we were away
      if (now - updatedAt > RESTORED_UPLOAD_IDLE) {
        delete stored[id];
        return;
      }

      uploadMetaRef.current[id] = { ...saved, processing: true, restored: true };
      ownedUploadsRef.current.add(id);
      armRestoredIdle(id);

      // reaches listeners already mounted; the DAM page is lazy, so it mostly
      // catches up in registerUploadListener instead
      notify(id, 'PROCESSING', processingProgress(saved), { kind: 'upload' });
    });

    writeStoredUploads(stored);
  }, []);

    useEffect(() => {
      const unsubscribe = stompService.subscribe('/user/topic/media.dam.final', (data) => {
        // A conflict is a question, not progress. Keep it out of the listener
        // fan-out entirely: it describes ONE file, while a progress row tracks the
        // whole activity, so letting it through would blank that row's status and
        // bar while its other files are still uploading.
        if (isConflictEvent(data)) {
          handleUploadConflict(data);
          return;
        }

        const id = data.activityId || data.uniqueId;

        // This tab's own uploads and downloads are reported by their handlers
        // below — never as the raw frame, where a per-file status 2 would mark
        // a whole folder upload done. Everything else (deletes and the other
        // activities, other sessions' jobs) goes to the listeners as it comes,
        // and refreshes the list when it lands.
        if (id && !isOwnJob(id)) {
          uploadListeners.current.forEach((cb) => cb({ ...data, activityId: id }));

          if (data.status === 2) scheduleRefresh();
        }

        handleDownloadSocket(data);
        handleUploadSocket(data);
      });

    return () => unsubscribe?.();
  }, []);

  useEffect(
    () => () => {
      orphanTimersRef.current.forEach((t) => clearTimeout(t));
      orphanTimersRef.current.clear();
      conflictTimersRef.current.forEach((t) => clearTimeout(t));
      conflictTimersRef.current.clear();
      uploadOrphanTimersRef.current.forEach((t) => clearTimeout(t));
      uploadOrphanTimersRef.current.clear();
      restoredIdleTimersRef.current.forEach((t) => clearTimeout(t));
      restoredIdleTimersRef.current.clear();
      if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);
    },
    [],
  );

  /* ----------------------------------
     DEBOUNCED LIST REFRESH
  ---------------------------------- */

  const scheduleRefresh = () => {
    if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);
    refreshTimerRef.current = setTimeout(() => {
      refreshTimerRef.current = null;
      setrefreshRef((p) => p + 1);
    }, 500);
  };

  /* ----------------------------------
     LISTENER NOTIFIER
  ---------------------------------- */

  const buildPayload = (id, status, progress, data = {}) => {
    const meta = uploadMetaRef.current[id] || {};

    const payload = {
      ...data,
      activityId: data.activityId || id,
      status,
      progress,
      totalNumberOfAsset: meta.totalNumberOfAsset,
      // assets the server has confirmed — 0 until processing starts
      successCount: data.successCount ?? meta.Responsecount ?? 0,
      showProgress: true,
    };

    // What this activity is called. Set the keys only when we have a value:
    // listeners merge this payload over the row they already hold, so an
    // undefined here would wipe a name that's already on screen.
    if (meta.folderName) payload.folderName = meta.folderName;
    if (!payload.fileName && meta.fileName) payload.fileName = meta.fileName;

    return payload;
  };

  const notify = (id, status, progress, data = {}) => {
    const payload = buildPayload(id, status, progress, data);

    uploadListeners.current.forEach((cb) => cb(payload));
  };

  /* ----------------------------------
     DOWNLOAD NOTIFIER

     fileName/fileType come from whatever we actually know:
       1. the name the server sent in content-disposition (best)
       2. a fileName in the job/socket payload
       3. a neutral placeholder — never a guessed extension
  ---------------------------------- */

  const notifyDownload = (id, status, progress, data = {}) => {
    const meta = downloadMetaRef.current[id] || {};
    const fileName = data.fileName || meta.fileName || '';

    notify(id, status, progress, {
      ...data,
      activityId: id,
      kind: 'download',
      fileName: fileName || 'Preparing download…',
      fileType: meta.fileType || extensionOf(fileName) || '',
      cancellable: CANCELLABLE_DOWNLOAD_STATUSES.includes(status),
    });
  };

  /* ----------------------------------
     DOWNLOAD SOCKET HANDLER
  ---------------------------------- */

  const handleDownloadSocket = async (data) => {
    const { uniqueId, status } = data;
    if (!uniqueId) return;

    if (!ownedDownloadsRef.current.has(uniqueId)) {
      // It may still become ours — the POST that returns downloadId might not
      // have resolved yet. Buffer it instead of acting on it.
      const list = earlyEventsRef.current.get(uniqueId) || [];
      list.push(data);
      earlyEventsRef.current.set(uniqueId, list);

      if (!orphanTimersRef.current.has(uniqueId)) {
        const timer = setTimeout(() => {
          // nobody claimed it -> belongs to another session, drop it
          earlyEventsRef.current.delete(uniqueId);
          orphanTimersRef.current.delete(uniqueId);
        }, ORPHAN_EVENT_TTL);

        orphanTimersRef.current.set(uniqueId, timer);
      }

      return;
    }

    // remember a server-supplied name if the socket carries one
    if (data.fileName) {
      downloadMetaRef.current[uniqueId] = {
        ...downloadMetaRef.current[uniqueId],
        fileName: data.fileName,
        fileType: extensionOf(data.fileName),
      };
    }

    if (status === 'PREPARING') {
      updateStatus(uniqueId, 'PREPARING', mapProgress('PREPARING', 100));
      notifyDownload(uniqueId, 'PREPARING', mapProgress('PREPARING', 100), data);
      return;
    }

    if (status === 'PROCESSING') {
      updateStatus(uniqueId, 'PROCESSING', mapProgress('PROCESSING', 100));
      notifyDownload(uniqueId, 'PROCESSING', mapProgress('PROCESSING', 100), data);
      return;
    }

    if (status === 'READY') {
      updateStatus(uniqueId, 'DOWNLOADING', mapProgress('DOWNLOADING', 0));
      notifyDownload(uniqueId, 'DOWNLOADING', mapProgress('DOWNLOADING', 0), data);

      // fires mid-transfer, as soon as content-disposition is readable
      const handleMeta = ({ fileName, fileType }) => {
        downloadMetaRef.current[uniqueId] = {
          ...downloadMetaRef.current[uniqueId],
          fileName,
          fileType,
        };

        setDownloadingAssets((prev) =>
          prev.map((d) => (d.id === uniqueId ? { ...d, fileName, fileType } : d)),
        );
      };

      try {
        await downloadAssetsFile(
          { downloadId: uniqueId },
          (downloadPercent) => {
            const progress = mapProgress('DOWNLOADING', downloadPercent);

            updateStatus(uniqueId, 'DOWNLOADING', progress);
            notifyDownload(uniqueId, 'DOWNLOADING', progress, data);
          },
          handleMeta,
        );

        updateStatus(uniqueId, 'DONE', DOWNLOAD_PROGRESS.DONE.end);
        notifyDownload(uniqueId, 2, DOWNLOAD_PROGRESS.DONE.end, data);

        cleanup(uniqueId);
      } catch (err) {
        if (err.cancelled) {
          // cancelDownload() already pushed the CANCELLED row and cleaned up
          cleanup(uniqueId);
          return;
        }

        console.error('[download] failed for', uniqueId, err.status || '', err);

        updateStatus(uniqueId, 'FAILED', 0);
        notifyDownload(uniqueId, 'FAILED', 0, {
          ...data,
          error: err.message,
          statusCode: err.status,
        });
        cleanup(uniqueId);
      }

      return;
    }

    if (status === 'FAILED') {
      updateStatus(uniqueId, 'FAILED', 0);
      notifyDownload(uniqueId, 'FAILED', 0, data);
      cleanup(uniqueId);
    }
  };

  handleDownloadSocketRef.current = handleDownloadSocket;

  /* ----------------------------------
     START DOWNLOAD
  ---------------------------------- */

  const startDownload = async (payload, apiURL) => {
    try {
      const job = await startDownloadAssets(payload, apiURL);

      if (!job?.downloadId) {
        throw new Error('Failed to start download: missing downloadId');
      }

      // claim ownership BEFORE anything else async happens
      ownedDownloadsRef.current.add(job.downloadId);

      if (job.fileName) {
        downloadMetaRef.current[job.downloadId] = {
          fileName: job.fileName,
          fileType: extensionOf(job.fileName),
        };
      }

      notifyDownload(job.downloadId, 'PREPARING', mapProgress('PREPARING', 0), {
        fileName: job.fileName,
      });

      setDownloadingAssets((prev) => [
        ...prev,
        {
          id: job.downloadId,
          payload,
          fileName: job.fileName,
          status: 'PREPARING',
          progress: mapProgress('PREPARING', 0),
          showProgress: true,
          cancellable: true,
        },
      ]);

      // replay anything that arrived before we knew the id
      const buffered = earlyEventsRef.current.get(job.downloadId);
      if (buffered) {
        earlyEventsRef.current.delete(job.downloadId);

        const timer = orphanTimersRef.current.get(job.downloadId);
        if (timer) {
          clearTimeout(timer);
          orphanTimersRef.current.delete(job.downloadId);
        }

        buffered.forEach((e) => handleDownloadSocket(e));
      }

      // ONLY the HTTP-200 path is truly immediate. Gating on job.status here
      // would double-fire whenever the 202 body carries a ready-ish status, and
      // the second GET returns 410 Gone.
      if (job.immediate && !buffered?.length) {
        handleDownloadSocket({ uniqueId: job.downloadId, status: 'READY' });
      }

      return job;
    } catch (err) {
      console.error('[download] failed to start', err.message || '', err);
    }
  };

  /* ----------------------------------
     CANCEL DOWNLOAD
  ---------------------------------- */

  const cancelDownload = (id) => {
    if (!id) return;

    // aborts the XHR if a transfer is running, flags the job either way, and
    // hits the server-side cancel route if one is configured in download.js
    cancelDownloadRequest(id);

    updateStatus(id, 'CANCELLED', 0);
    notifyDownload(id, 'CANCELLED', 0, { cancelled: true });

    cleanup(id);
  };

  const cancelAllDownloads = () => {
    const ids = new Set([
      ...cancelAllDownloadRequests(),
      ...downloadingAssets.map((d) => d.id),
      ...ownedDownloadsRef.current,
    ]);

    ids.forEach((id) => cancelDownload(id));
  };

  /* ----------------------------------
     STATE HELPERS
  ---------------------------------- */

  const updateStatus = (id, status, progress = 0) => {
    setDownloadingAssets((prev) => {
      const updated = prev.map((d) =>
        d.id === id
          ? {
              ...d,
              status,
              progress,
              showProgress: true,
              cancellable: CANCELLABLE_DOWNLOAD_STATUSES.includes(status),
            }
          : d,
      );

      const active = updated.find((d) => d.status === 'DOWNLOADING');

      setGlobalDownloadProgress(active ? active.progress : 0);

      return updated;
    });
  };

  const cleanup = (id) => {
    ownedDownloadsRef.current.delete(id);
    earlyEventsRef.current.delete(id);

    const timer = orphanTimersRef.current.get(id);
    if (timer) {
      clearTimeout(timer);
      orphanTimersRef.current.delete(id);
    }

    // keep the name around briefly so a CANCELLED/FAILED row stays labelled
    setTimeout(() => {
      delete downloadMetaRef.current[id];
    }, 60_000);

    setDownloadingAssets((prev) => {
      const updated = prev.filter((d) => d.id !== id);

      const active = updated.find((d) => d.status === 'DOWNLOADING');

      setGlobalDownloadProgress(active ? active.progress : 0);

      return updated;
    });
  };

  /* ----------------------------------
     REGISTER LISTENER
  ---------------------------------- */

  // Stable, so a listener's effect registers once rather than on every render
  // of this provider — each registration replays the state below.
  const registerUploadListener = useCallback((cb) => {
    uploadListeners.current.push(cb);

    // Bring a late listener up to date with uploads the server is still
    // processing: the DAM page mounting after a reload restored them, or
    // after the user navigated away and back mid-upload.
    ownedUploadsRef.current.forEach((id) => {
      const meta = uploadMetaRef.current[id];

      // one still sending shows up with its next progress tick anyway
      if (!meta?.processing) return;

      cb(buildPayload(id, 'PROCESSING', processingProgress(meta), { kind: 'upload' }));
    });

    return () => {
      uploadListeners.current = uploadListeners.current.filter((fn) => fn !== cb);
    };
  }, []);

  /* ----------------------------------
     START UPLOAD

     The upload id is ours: generated here and sent to /uploadFile as the
     `activityId` param, and the server keys every socket event for the upload
     by it. So the upload is claimed before the first byte goes out, and
     nothing the server reports can arrive too early to be counted.
  ---------------------------------- */

  const UploadFiles = async (formData, totalfiles, API_URL) => {
    const uploadId = createUploadId();

    uploadMetaRef.current[uploadId] = {
      totalNumberOfAsset: totalfiles,
      Responsecount: 0,
      // folderName for a folder, fileName for a lone asset — notify() forwards
      // whichever one is set
      ...describeUpload(formData),
    };

    // claim this upload for THIS session only
    ownedUploadsRef.current.add(uploadId);
    sendingUploadsRef.current.add(uploadId);

    notify(uploadId, 'PREPARING', 0, { uploadId, kind: 'upload' });

    try {
      const job = await startUploadAssets(
        formData,
        (percent) => {
          const meta = uploadMetaRef.current[uploadId];

          // The server can start reporting on files before the response is
          // back; once it has, don't drag the row back to "Uploading".
          if (!meta || meta.processing) return;

          // Only the bar moves here. Bytes sent say nothing about which files
          // are done, so the count stays at what the server has confirmed.
          notify(uploadId, 'UPLOADING', mapProgress('UPLOADING', percent, UPLOAD_PROGRESS), {
            kind: 'upload',
          });
        },
        API_URL,
        uploadId,
      );

      sendingUploadsRef.current.delete(uploadId);

      // /uploadFile keys everything by the id we sent. Other upload endpoints
      // (brand assets) may still issue their own — follow theirs if so.
      const id =
        API_URL && API_URL !== UploadAssetsURL && job.uploadId && job.uploadId !== uploadId
          ? adoptServerUploadId(uploadId, job.uploadId)
          : uploadId;

      // every file may already have reported, or the upload failed, while we
      // were waiting on the response
      if (!ownedUploadsRef.current.has(id)) return job;

      const meta = uploadMetaRef.current[id];
      meta.processing = true;

      // from here it's all server-side, so it can survive a reload
      storeUpload(id, meta);

      notify(id, 'PROCESSING', processingProgress(meta), { kind: 'upload' });

      return job;
    } catch (err) {
      sendingUploadsRef.current.delete(uploadId);

      notify(uploadId, 'FAILED', 0, { kind: 'upload' });

      releaseUpload(uploadId);

      throw err;
    }
  };

  /* ----------------------------------
     ENDPOINTS THAT ISSUE THEIR OWN ID

     Those report under an id we only learn from the response, so their events
     may have arrived (and been held by bufferUploadEvent) before it. Move the
     upload over to that id, re-key the listeners' row, then replay.
  ---------------------------------- */

  const adoptServerUploadId = (ourId, serverId) => {
    uploadMetaRef.current[serverId] = uploadMetaRef.current[ourId];
    delete uploadMetaRef.current[ourId];

    ownedUploadsRef.current.delete(ourId);
    ownedUploadsRef.current.add(serverId);

    notify(serverId, 'SWAP', 0, {
      action: 'SWAP',
      oldId: ourId,
      newId: serverId,
      kind: 'upload',
    });

    // replay conflicts the server raised before we knew its id
    const bufferedConflicts = earlyConflictsRef.current.get(serverId);
    if (bufferedConflicts) {
      earlyConflictsRef.current.delete(serverId);

      const timer = conflictTimersRef.current.get(serverId);
      if (timer) {
        clearTimeout(timer);
        conflictTimersRef.current.delete(serverId);
      }

      bufferedConflicts.forEach((e) => handleUploadConflict(e));
    }

    // after SWAP, so the replayed updates land on the re-keyed row instead of
    // being overwritten by it
    takeEarlyUploadEvents(serverId).forEach((e) => handleUploadSocket(e));

    return serverId;
  };

  /* ----------------------------------
     FINISH AN UPLOAD ACTIVITY

     Every asset has reported (or the ones left were abandoned): mark the row
     done, drop the bookkeeping and refresh the list.
  ---------------------------------- */

  const completeUpload = (requestId, data = {}) => {
    const meta = uploadMetaRef.current[requestId] || {};

    notify(requestId, 2, UPLOAD_PROGRESS.DONE.end, {
      ...data,
      successCount: meta.Responsecount,
    });

    releaseUpload(requestId);

    scheduleRefresh();
  };

  // drop everything this tab holds for an upload that is over, one way or
  // another — including its sessionStorage entry, so a reload won't revive it
  const releaseUpload = (requestId) => {
    delete uploadMetaRef.current[requestId];
    ownedUploadsRef.current.delete(requestId);
    finishedUploadsRef.current.add(requestId);

    clearTimeout(restoredIdleTimersRef.current.get(requestId));
    restoredIdleTimersRef.current.delete(requestId);

    forgetStoredUpload(requestId);
  };

  // (re)start the clock on a restored upload — see RESTORED_UPLOAD_IDLE
  const armRestoredIdle = (id) => {
    clearTimeout(restoredIdleTimersRef.current.get(id));

    const timer = setTimeout(() => {
      restoredIdleTimersRef.current.delete(id);
      if (ownedUploadsRef.current.has(id)) completeUpload(id, { kind: 'upload' });
    }, RESTORED_UPLOAD_IDLE);

    restoredIdleTimersRef.current.set(id, timer);
  };

  /* ----------------------------------
     EARLY / FOREIGN UPLOAD EVENTS

     An event for an upload we haven't claimed may still be ours: from an
     endpoint that issues its own id (see adoptServerUploadId), reporting
     before the response hands us that id. Hold it so adoptServerUploadId can
     replay it; drop it once nothing has claimed it for a while. (Showing it,
     and refreshing the list, is the subscription's job — it can't tell this
     apart from any other activity.)
  ---------------------------------- */

  // hand back whatever was held for `id` and stop its clock
  const takeEarlyUploadEvents = (id) => {
    const events = earlyUploadEventsRef.current.get(id) || [];

    earlyUploadEventsRef.current.delete(id);
    clearTimeout(uploadOrphanTimersRef.current.get(id));
    uploadOrphanTimersRef.current.delete(id);

    return events;
  };

  const bufferUploadEvent = (id, data) => {
    const list = earlyUploadEventsRef.current.get(id) || [];
    list.push(data);
    earlyUploadEventsRef.current.set(id, list);

    clearTimeout(uploadOrphanTimersRef.current.get(id));

    // nobody claimed it -> not an upload of ours
    const timer = setTimeout(() => takeEarlyUploadEvents(id), ORPHAN_EVENT_TTL);

    uploadOrphanTimersRef.current.set(id, timer);
  };

  /* ----------------------------------
     HANDLE UPLOAD SOCKET
  ---------------------------------- */

  const handleUploadSocket = (data) => {
    const requestId = data.activityId || data.uniqueId;
    const { status, percent = 0 } = data;

    if (!requestId) return;

    const meta = uploadMetaRef.current[requestId];

    // not claimed (yet) — may still be ours, see bufferUploadEvent
    if (!meta || !ownedUploadsRef.current.has(requestId)) {
      bufferUploadEvent(requestId, data);
      return;
    }

    if (meta.restored) armRestoredIdle(requestId);

    // the server is working on it now — the bytes phase is over for this row
    meta.processing = true;

    const enriched = {
      ...data,
      activityId: requestId,
      kind: 'upload',
      showProgress: true,
    };

    const totalAssets = meta.totalNumberOfAsset || 0;

    // Save the count so a reload resumes from it, then report. Pass it
    // explicitly: `enriched` carries the server frame, and any successCount of
    // its own would otherwise win in notify().
    const notifyProcessing = () => {
      storeUpload(requestId, meta);

      notify(requestId, 'PROCESSING', processingProgress(meta), {
        ...enriched,
        successCount: meta.Responsecount,
      });
    };

    if (status === 1) {
      notifyProcessing();
      return;
    }

    if (status === 2) {
      // status 2 means ONE asset finished, not the activity. Count the events
      // we've actually received rather than trusting any count carried in the
      // payload; the upload is done once every asset has reported.
      meta.Responsecount = (meta.Responsecount || 0) + 1;

      if (!totalAssets || meta.Responsecount < totalAssets) {
        notifyProcessing();
        return;
      }

      completeUpload(requestId, enriched);

      return;
    }

    if (status === 'FAILED') {
      notify(requestId, 'FAILED', 0, { ...enriched, successCount: meta.Responsecount });

      releaseUpload(requestId);

      // the upload is over — show whatever did land before it failed
      if (meta.Responsecount > 0) scheduleRefresh();

      return;
    }

    // anything else goes to the listeners as-is, with a progress value only
    // when the status is one of our phases
    uploadListeners.current.forEach((cb) =>
      cb(
        UPLOAD_PROGRESS[status]
          ? { ...enriched, progress: mapProgress(status, percent, UPLOAD_PROGRESS) }
          : enriched,
      ),
    );
  };

  handleUploadSocketRef.current = handleUploadSocket;

  /* ----------------------------------
     HANDLE UPLOAD CONFLICT

     One frame per duplicate file. The asset is parked server-side until the
     user answers, so no completion event is coming for it — the activity's
     progress row deliberately keeps waiting until the conflict is resolved.
  ---------------------------------- */

  const handleUploadConflict = (data) => {
    const activityId = data.activityId || data.uniqueId;
    if (!activityId) return;

    // Same fan-out problem as downloads: /user/topic reaches every tab and every
    // device on this login. Only the session that started the upload may answer
    // for it — otherwise the popup pops up in all of them.
    if (!ownedUploadsRef.current.has(activityId)) {
      // it may still become ours: the POST handing us the uploadId can resolve
      // after the server has already spotted the duplicate
      const list = earlyConflictsRef.current.get(activityId) || [];
      list.push(data);
      earlyConflictsRef.current.set(activityId, list);

      if (!conflictTimersRef.current.has(activityId)) {
        const timer = setTimeout(() => {
          // nobody claimed it -> another session's upload, drop it
          earlyConflictsRef.current.delete(activityId);
          conflictTimersRef.current.delete(activityId);
        }, ORPHAN_EVENT_TTL);

        conflictTimersRef.current.set(activityId, timer);
      }

      return;
    }

    const fileName = pickConflictFileName(data);

    // the asset name, scoped to its activity: one question per clashing file
    const key = `${activityId}::${fileName}`;

    // a reconnect can replay frames; one question per file
    if (conflictKeysRef.current.has(key)) return;
    conflictKeysRef.current.add(key);

    const meta = uploadMetaRef.current[activityId];
    if (meta) meta.conflictCount = (meta.conflictCount || 0) + 1;

    const conflict = {
      key,
      activityId,
      fileName,
      folderId: data.folderId ?? data.parentFolderId ?? null,
      // untouched frame: whatever ids the resolve API turns out to need
      // (assetId, versionId, tempPath, ...) are still in here
      payload: data,
      receivedAt: Date.now(),
    };

    uploadConflictsRef.current = [...uploadConflictsRef.current, conflict];
    setUploadConflicts(uploadConflictsRef.current);
  };

  /* ----------------------------------
     ABANDON A CONFLICTED FILE

     Cancelling means the server will never report on that file, so the row
     would sit at "Processing" forever waiting for an event that isn't coming.
     Shrink what the activity expects instead.
  ---------------------------------- */

  const abandonConflictedFile = ({ activityId, fileName }) => {
    const meta = uploadMetaRef.current[activityId];
    if (!meta) return;

    meta.conflictCount = Math.max((meta.conflictCount || 1) - 1, 0);

    if (meta.totalNumberOfAsset > 0) meta.totalNumberOfAsset -= 1;

    const responses = meta.Responsecount || 0;

    // nothing was ever going to land — close the row out as cancelled, named
    // after the file the user declined
    if (meta.totalNumberOfAsset <= 0 && responses === 0) {
      notify(activityId, 'CANCELLED', 0, { kind: 'upload', activityId, fileName });

      releaseUpload(activityId);

      return;
    }

    // this was the last thing outstanding
    if (responses >= meta.totalNumberOfAsset) {
      completeUpload(activityId, { kind: 'upload', activityId });
      return;
    }

    // still running, with one file fewer to wait for
    storeUpload(activityId, meta);
  };

  /* ----------------------------------
     RESOLVE UPLOAD CONFLICT

     choice: CONFLICT_CHOICE.REPLACE | KEEP_BOTH | CANCEL

     The asset stays parked server-side until update-upload-status lands, so a
     question is only taken off the queue once its call succeeds — a failed one
     stays on screen for the user to try again.

     REPLACE/KEEP_BOTH leave the activity's progress row running: the server
     still owes it a completion event for that file.
  ---------------------------------- */

  const resolveUploadConflict = async (key, choice, { applyToAll = false } = {}) => {
    const queue = uploadConflictsRef.current;
    const target = queue.find((c) => c.key === key);

    if (!target) return { ok: false, resolved: [], failed: [] };

    const batch = applyToAll ? queue : [target];

    const outcomes = await Promise.allSettled(
      batch.map((c) => updateUploadStatus(buildConflictStatusPayload(c, choice))),
    );

    const resolved = [];
    const failed = [];

    batch.forEach((c, i) => {
      if (outcomes[i].status === 'fulfilled') resolved.push(c);
      else failed.push({ conflict: c, reason: outcomes[i].reason });
    });

    if (resolved.length) {
      const done = new Set(resolved.map((c) => c.key));

      done.forEach((k) => conflictKeysRef.current.delete(k));

      uploadConflictsRef.current = uploadConflictsRef.current.filter((c) => !done.has(c.key));
      setUploadConflicts(uploadConflictsRef.current);

      if (choice === CONFLICT_CHOICE.CANCEL) {
        resolved.forEach((c) => abandonConflictedFile(c));
      }
    }

    if (failed.length) {
      console.error('[upload] conflict resolution failed', failed);

      toast.error(
        failed.length > 1
          ? `Couldn't update ${failed.length} files`
          : `Couldn't update ${failed[0].conflict.fileName}`,
      );
    }

    return { ok: failed.length === 0, resolved, failed };
  };

  /* ----------------------------------
     WARN ON CLOSE + FLUSH PARTIAL BANDWIDTH
  ---------------------------------- */

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      const downloadsActive =
        hasActiveDownloads() ||
        downloadingAssets.some(
          (d) => d.status !== 'DONE' && d.status !== 'FAILED' && d.status !== 'CANCELLED',
        );

      // Only while bytes are still going up: leaving then kills the upload.
      // Once the server has it, a reload just picks the row back up.
      const uploadsActive = sendingUploadsRef.current.size > 0;

      if (!downloadsActive && !uploadsActive) return;

      // trigger the browser's "leave site?" confirmation
      e.preventDefault();
      e.returnValue = '';
      return '';
    };

    const handlePageHide = () => {
      // fires only when the page is genuinely being unloaded (not on cancel),
      // so reporting here won't double-count against normal completion
      flushPendingBandwidth();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('pagehide', handlePageHide);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, [downloadingAssets]);

  /* ----------------------------------
     PROVIDER VALUE
  ---------------------------------- */

  return (
    <DownloadAssetsContext.Provider
      value={{
        startDownload,
        cancelDownload,
        cancelAllDownloads,
        downloadingAssets,
        registerUploadListener,
        globalDownloadProgress,
        DOWNLOAD_PROGRESS,
        UploadFiles,
        UPLOAD_PROGRESS,
        refreshRef,
        uploadConflicts,
        resolveUploadConflict,
        CONFLICT_CHOICE,
      }}
    >
      {children}
    </DownloadAssetsContext.Provider>
  );
};

/* ----------------------------------
   HOOK
---------------------------------- */

export const useDownloadAssets = () => {
  const ctx = useContext(DownloadAssetsContext);

  if (!ctx) {
    throw new Error('useDownloadAssets must be used inside DownloadAssetsProvider');
  }

  return ctx;
};
